export const initCircleAnimation = element => {
  const strokeDashoffset = element.getAttribute('data-stroke-dashoffset');
  element.setAttribute('stroke-dashoffset', strokeDashoffset);
};

export const initNumberAnimations = container => {
  const elements = [...container.querySelectorAll('.js-number-animation')];

  const animateIntNumber = (element, duration) => {
    const unit = element.getAttribute('data-unit') || '';
    const unitLeft = element.getAttribute('data-unit-left') || '';
    const finalNumber = Number(element.getAttribute('data-final-number'));

    const startTime = performance.now();
    let startNumber = 0;

    const updateNumber = () => {
      const elapsed = performance.now() - startTime;
      startNumber = Math.min(finalNumber, (elapsed / duration) * finalNumber);
      element.innerText = unitLeft + Math.round(startNumber) + unit;

      if (startNumber < finalNumber) {
        requestAnimationFrame(updateNumber);
      } else {
        element.innerText = unitLeft + finalNumber + unit;
      }
    };

    requestAnimationFrame(updateNumber);
  };

  const animateDecimalNumber = (element, duration) => {
    const unit = element.getAttribute('data-unit') || 'x';
    const unitLeft = element.getAttribute('data-unit-left') || '';
    const finalNumber = parseFloat(element.getAttribute('data-final-number'));
    const decimalPlaces = (finalNumber.toString().split('.')[1] || '').length;
    const frameRate = 60; // Количество кадров в секунду (FPS)
    const totalFrames = Math.round((duration / 1000) * frameRate);
    const step = finalNumber / totalFrames;
    let currentFrame = 0;
    let startNumber = 0;

    const interval = setInterval(() => {
      startNumber += step;
      const roundedNumber =
        Math.round(startNumber * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
      element.innerText = unitLeft + roundedNumber.toFixed(decimalPlaces) + unit;
      currentFrame++;

      if (currentFrame >= totalFrames) {
        element.innerText = unitLeft + finalNumber.toFixed(decimalPlaces) + unit;
        clearInterval(interval);
      }
    }, 1000 / frameRate);
  };

  elements.forEach(element => {
    const number = Number(element.getAttribute('data-final-number'));

    if (Number.isInteger(number)) {
      animateIntNumber(element, 2000);
    } else {
      animateDecimalNumber(element, 2000);
    }
  });
};
